import { useNavigate } from 'application/providers/RouterProvider';
import { toast } from '@shared/ui';
import { DEFAULT_ERROR_MESSAGE } from '@shared/config';
import { TEXTS } from 'application/pages/texts';
import { getStreamsCategoryPath, StreamsCategoryParamValues } from 'application/pages/StreamPage';
import { useAccountCompanyIds } from 'application/hooks';

import { UseStreamRemoveModalControllerProps } from './types';

const useStreamRemoveModalController = ({
  targetStreamId,
  removeStream,
  getSavedStreams,
  close,
}: UseStreamRemoveModalControllerProps) => {
  const navigate = useNavigate();

  const companyIds = useAccountCompanyIds();

  const onStreamRemove = async () => {
    try {
      if (!targetStreamId) {
        throw new Error();
      }

      const okRemove = await removeStream(+targetStreamId);

      if (!okRemove) {
        throw new Error();
      }

      await getSavedStreams(companyIds);
      navigate(getStreamsCategoryPath(StreamsCategoryParamValues.SAVED));

      toast.info(TEXTS.MODAL_STREAM_REMOVE_SUCCESS_MESSAGE);

      close?.();
    } catch (e) {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  };

  return {
    onStreamRemove,
  };
};

export default useStreamRemoveModalController;
